import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'user-blocked',
  templateUrl: './user-blocked.component.html',
  styleUrls: ['./user-blocked.component.scss']
})
export class UserBlockedComponent implements OnInit {

  currentUser: any;

  constructor(private readonly authService: AuthService,
              private router: Router) { }

  ngOnInit(): void {
    this.authService.getCurrentUser().then(user => {
      this.currentUser = user;
    });
  }

  backHome(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

}
